import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/inputFields/InputField";
import Button from "../../../components/buttons/Button";
import FormikDropdown from "../../../components/inputFields/FormikDropDown";
import { formateDateFromMinus, formateDateToMinus } from "../../../utils/FormatDateTime";
import { toast } from "react-toastify";
import Breadcrumbs from "../../../components/BreadCrumbs";
import FilePickerField from "../../../components/inputFields/FilePickerField";
import { newPatchPatient, newPostNewHudPatient } from "../../../services/new_clinic/new_hud_patients";
import { getUserName } from "../../../utils/localStoarege";
const NewPatientForm = () => {
    const { slug } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedImage, setImage] = useState(null);

    const [initialValues, setInitialValues] = useState({
        name: "",
        image: null,
        patient_type: "New",
        gender: "",
        phone_number: "",
        alt_phone_number: "",
        dob: "",
        // country: "India",
        // state: "",
        // city: "",
        address: "",
        skin_type: "V",
        system_code: "TBD",
        branch: "",
    });

    const [filteredCities, setFilteredCities] = useState([]);
    const isEditMode = slug !== "add";

    const handleImage = (file) => {
        if (file instanceof File || file instanceof Blob) {
            setImage(file);
        } else {
            console.error("Invalid file selected:", file);
        }
    };

    useEffect(() => {
        if (isEditMode) {
            const patientData = location.state;
            if (patientData) {
                setImage(patientData.image);
                setInitialValues({
                    name: patientData.name || "",
                    image: patientData.image || null,
                    patient_type: patientData.patient_type || "New",
                    gender: patientData.gender == "Male" ? "M" : patientData.gender == "Female" ? "F" : patientData.gender == "Other" ? "O" : patientData.gender || "",
                    phone_number: patientData.phone_number || "",
                    dob: patientData.dob || "",
                    // country: "India",
                    // state: patientData.state || "",
                    // city: patientData.city || "",
                    alt_phone_number: patientData.alt_phone_number || "",
                    address: patientData.address || "",
                    skin_type: patientData.skin_type || "V",
                    system_code: patientData.system_code || "",
                    branch: patientData.branch || "",
                });

                // setFilteredCities(
                //     patientData.state ? cscCities[0][patientData.state] || [] : []
                // );
            }
        }
    }, [isEditMode, location.state]);


    // const handleStateChange = (state) => {
    //     setFilteredCities(state ? cscCities[0][state] || [] : []);
    // };

    const validationSchema = Yup.object({
        name: Yup.string().required("Full Name is required"),
        patient_type: Yup.string().required("Patient type is required"),
        gender: Yup.string().required("Gender is required"),
        phone_number: Yup.string().required("Phone number is required"),
        dob: Yup.string().required("Date of Birth is required"),
        // state: Yup.string().required("State is required"),
        // city: Yup.string().required("City is required"),
        address: Yup.string().required("City is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        const formData = new FormData();
        formData.append("name", values.name);
        if (selectedImage && typeof selectedImage === "object") {
            formData.append("image", selectedImage);
        }
        formData.append("patient_type", values.patient_type);
        formData.append("gender", values.gender);
        formData.append("phone_number", values.phone_number);
        formData.append("dob", values.dob);
        formData.append("alt_phone_number", values.alt_phone_number);
        formData.append("address", values.address);
        // formData.append("country", values.country);
        // formData.append("state", values.state);
        // formData.append("city", values.city);
        formData.append("skin_type", values.skin_type);
        formData.append("system_code", values.system_code);
        if (getUserName() && getUserName() !== null) {
            formData.append("branch", getUserName());
        }
        try {
            if (isEditMode) {
                // Edit operation
                const response = await newPatchPatient(location.state.id, formData);
                if (response?.status === 200) {
                    toast.success("Patient updated successfully!");
                    navigate("/new-hud-patients");
                } else if (response?.status === 400) {
                    toast.error(response?.data?.error);
                }
                else {
                    toast.error("Oops! Something went wrong, please try again.");
                }
            } else {
                // Create operation
                const response = await newPostNewHudPatient(formData);
                if (response?.status === 201) {
                    toast.success("Patient added successfully!");
                    navigate("/new-hud-patients");
                } else if (response?.status === 400) {
                    toast.error(response?.data?.error);
                } else {
                    toast.error("Oops! Something went wrong, please try again.");
                }
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-md">
            <Breadcrumbs items={[
                { name: 'Home', link: '/package-invoice' },
                { name: 'Patients', link: '/new-hud-patients' },
                { name: isEditMode ? "Edit Patient" : "Add Patient" },
            ]} />
            <h2 className="text-xs font-semibold my-4">
                {isEditMode ? "Edit Patient" : "Add Patient"}
            </h2>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="space-y-4">
                        {/* <div key={values.id} className="w-48 h-48">
                            <ImagePicker
                                label="Patient Photo"
                                preloadedImage={selectedImage}
                                onImageSelect={handleImage}
                            />
                        </div> */}
                        <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
                            <InputField
                                label="Full Name"
                                name="name"
                                type="text"
                                placeholder="Enter patient's full name"
                                required={!isEditMode}
                                disable={isEditMode}
                            />
                            <FormikDropdown
                                label="Patient Type"
                                name="patient_type"
                                placeholder="Select Patient Type"
                                required={!isEditMode}
                                disabled={isEditMode}
                                options={[
                                    { label: "New", value: "New" },
                                    { label: "Old", value: "Old" },
                                ]}
                            />
                            <InputField
                                label="Date of Birth"
                                name="dob"
                                type="date"
                                required={!isEditMode}
                                disable={isEditMode}
                            />
                            <FormikDropdown
                                label="Gender"
                                name="gender"
                                placeholder="Select Gender"
                                required={!isEditMode}
                                disabled={isEditMode}
                                options={[
                                    { label: "Male", value: "M" },
                                    { label: "Female", value: "F" },
                                    { label: "Other", value: "O" },
                                ]}
                            />
                            <InputField
                                label="Phone Number"
                                name="phone_number"
                                type="text"
                                placeholder="Enter phone number"
                                required={!isEditMode}
                                disable={isEditMode}
                            />
                            <InputField
                                label="Alt. Phone Number"
                                name="alt_phone_number"
                                type="text"
                                placeholder="Enter alternate phone number"
                                disable={isEditMode}
                            />
                            <InputField
                                label="Address"
                                name="address"
                                type="text"
                                placeholder="Enter address"
                                required={!isEditMode}
                                disable={isEditMode}
                            />

                            <InputField
                                label="Skin Type"
                                name="skin_type"
                                type="text"
                                placeholder="Enter skin type"
                                disable={isEditMode}
                            />
                            <div className="flex flex-row gap-2 items-end">
                                {
                                    initialValues.image ?
                                        <img src={initialValues.image} alt={initialValues.image} className="border rounded-sm aspect-square h-12 w-12" />
                                        : <></>
                                }
                                <div className="flex-1">
                                    <FilePickerField
                                        label="Patient Photo"
                                        preloadedImage={selectedImage}
                                        onFileSelect={handleImage}
                                        acceptedFormats=".jpg,.png,.jpeg"
                                        disabled={isEditMode}
                                    />
                                </div>
                            </div>
                            <FormikDropdown
                                label="System Code"
                                name="system_code"
                                placeholder="Select System Code"
                                needSearch
                                disabled={isEditMode}
                                options={[
                                    { label: "TBD", value: "TBD" },
                                    { label: "NB21", value: "NB21" },
                                    { label: "COMBI 18", value: "COMBI 18" },
                                    { label: "H&F", value: "H&F" },
                                    { label: "PHOTO", value: "PHOTO" },
                                    { label: "F&S", value: "F&S" },
                                ]}
                            />
                        </div>

                        <div className="flex gap-4">
                            {!isEditMode && (
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 text-xs rounded"
                                    disabled={isSubmitting}
                                >
                                    Add
                                </Button>
                            )}
                            <Button
                                type="button"
                                className="bg-gray-500 text-white px-4 py-2 text-xs rounded"
                                onClick={() => navigate("/new-hud-patients")}
                            >
                                Back
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div >
    );
};

export default NewPatientForm;
